var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"withNavbar":"","withNavigation":""}},[_c('main',[(_vm.config.TYPEFORM_ID)?_c('TypeformWidget',{attrs:{"id":_vm.config.TYPEFORM_ID},on:{"submit":_vm.onSubmit}}):_c('h3',[_vm._v(" Typeform is not configured ! ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }